import React from "react";
import "./UserPopup.css";

import images from "../../../../Utils/importImages";
import RegisterLogin from "./RegisterLogin";

function UserPopup({ Open, onClose }) {
  if (!Open) return null; // If Open is false, don't render the popup

  return (
    <div className="user-popup-overlay" onClick={onClose}>
      <div
        className={`user-popup-content`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="user-popup-content-layer">
          <div className="user-popup-data">
            <div className="ads">
              <div className="ad-content">
                <img src={images["ads-img.svg"]} alt="ads" className="ad-img" />
                <div className="ad-title averta_regular color_white font25">
                  Discount title 1
                </div>
                <div className="ad-discription averta_regular color_white font18">
                  Discount Title 1
                </div>
              </div>
            </div>
            <div className="work-panel">
              <img
                className="cross"
                src={images["cross-dismiss.svg"]}
                alt=""
                srcset=""
                onClick={() => onClose()}
              />
              <RegisterLogin onClose={onClose} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserPopup;
